export default "/images/vendor/@coreui/icons/svg/flag/cif-cn.svg?1fdca5bf75de56adba9fe31bef976325";